import { vars } from '@sixfold/common-ui/dist/lib/css';
import { style } from '@vanilla-extract/css';

export const toolbar = style({
  backgroundColor: vars.color.neutral.bg.accent.subtle.default,
  borderRadius: vars.size.radius.small,
  padding: vars.size.spacing.small,
  margin: vars.size.spacing.small,
});
